<template>
	<div class="container">
		<div class="content">
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/my/index' }">个人中心</el-breadcrumb-item>
					<el-breadcrumb-item>我的保单</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="policies-card">
				<div class="policies-header">
					<div class="policies-title">保单列表</div>
					<div class="policies-count">共找到 5 份保单</div>
				</div>

				<table class="policies-table">
					<thead>
						<tr>
							<th>保单信息</th>
							<th>保险期间</th>
							<th>保费金额</th>
							<th>保单状态</th>
							<th>操作</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in list" :key="index">
							<td>
								<div class="policy-name">{{ item.goods_name }}</div>
								<div class="policy-desc">保单号: {{ item.policy_no || '暂未生成' }}</div>
							</td>
							<td>{{ item.pln_start_date }} 至 {{ item.pln_end_date }}</td>
							<td>¥{{ item.amount }}</td>
							<td>
								<span :class="'policy-status status-' + item.status">
									{{ item.statusText }}
								</span>
							</td>
							<td>
								<div class="policy-actions">
									<button @click="$navto('/my/insureDetail?id=' + item.id)" class="action-btn primary">查看详情</button>
									<button class="action-btn">下载</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				
				<div class="pagination" v-if="list.length > 0 && total > form._size">
					<el-pagination 
						background 
						layout="prev, pager, next, total" 
						:total="total" 
						:page-size="form._size"
						:current-page="form._page"
						@current-change="currentChange"
					/>
				</div>
			</div>
		</div>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				form: {
					_page: 1,
					_size: 10,
					_order: 'id',
					_isreverse: 1,
				},
				list: [],
				total: 0,
			}
		},
		mounted() {
			this.ActionList();
		},
		methods: {
			currentChange(e){
				this.form._page = e;
				this.ActionList();
			},
			ActionList(){
				this.$load();
				this.$get('app-order', this.form, true).then(res => {
					this.list  = res.data;
					this.total = res.extra.pageInfo.count;
				}).catch(err => {
					this.$message.error(err);
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 85%;
				margin: 15px auto 30px;
			}

			/* 平板适配 */
			@media (max-width: 1023px) and (min-width: 768px) {
				width: 95%;
				margin: 10px auto 20px;
			}

			/* 手机适配 */
			@media (max-width: 767px) {
				width: 100%;
				margin: 0 auto 20px;
				padding: 0 15px;
			}

			.breadcrumb {
				margin-bottom: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					margin-bottom: 15px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					margin-bottom: 12px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					margin-bottom: 10px;
					padding: 0 10px;
				}
			}

			/* 保单列表 */
			.policies-card {
				background: white;
				border-radius: 12px;
				padding: 24px;
				box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
				margin-top: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 20px;
					margin-top: 15px;
					border-radius: 10px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 16px;
					margin-top: 12px;
					border-radius: 8px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 12px;
					margin-top: 10px;
					border-radius: 6px;
					overflow-x: auto;
				}
				
				.pagination {
					display: flex;
					justify-content: center;
					margin-top: 30px;
					
					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						margin-top: 25px;
					}

					/* 平板适配 */
					@media (max-width: 1023px) and (min-width: 768px) {
						margin-top: 20px;
					}

					/* 手机适配 */
					@media (max-width: 767px) {
						margin-top: 15px;
					}
					
					::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
						background-color: #2280FD;
						color: white;
					}
					
					::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
						color: #2280FD;
					}

					/* 手机分页适配 */
					@media (max-width: 767px) {
						::v-deep .el-pagination {
							display: flex;
							flex-wrap: wrap;
							justify-content: center;
						}
						
						::v-deep .el-pagination .el-pager li,
						::v-deep .el-pagination .btn-prev,
						::v-deep .el-pagination .btn-next {
							min-width: 32px;
							height: 32px;
							line-height: 32px;
							font-size: 12px;
						}
					}
				}
			}

			.policies-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					margin-bottom: 16px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					margin-bottom: 12px;
					flex-direction: column;
					align-items: flex-start;
					gap: 8px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					margin-bottom: 10px;
					flex-direction: column;
					align-items: flex-start;
					gap: 6px;
				}
			}

			.policies-title {
				font-size: 18px;
				font-weight: 600;
				color: #333;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 17px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					font-size: 16px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					font-size: 16px;
				}
			}

			.policies-count {
				color: #666;
				font-size: 14px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 13px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					font-size: 13px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					font-size: 12px;
				}
			}

			.policies-table {
				width: 100%;
				border-collapse: collapse;

				/* 手机适配 - 表格水平滚动 */
				@media (max-width: 767px) {
					min-width: 600px;
				}
			}

			.policies-table th {
				background: #f8f9fa;
				padding: 16px;
				text-align: left;
				font-weight: 600;
				color: #333;
				border-bottom: 1px solid #e0e0e0;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 14px 12px;
					font-size: 14px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 12px 10px;
					font-size: 13px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 10px 8px;
					font-size: 12px;
				}
			}

			.policies-table td {
				padding: 16px;
				border-bottom: 1px solid #f0f0f0;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 14px 12px;
					font-size: 14px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 12px 10px;
					font-size: 13px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 10px 8px;
					font-size: 12px;
				}
			}

			.policies-table tr:hover {
				background: #f8f9fa;
			}

			.policy-name {
				font-weight: 500;
				color: #333;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 14px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					font-size: 13px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					font-size: 13px;
				}
			}

			.policy-desc {
				font-size: 12px;
				color: #666;
				margin-top: 4px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 11px;
					margin-top: 3px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					font-size: 11px;
					margin-top: 2px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					font-size: 10px;
					margin-top: 2px;
				}
			}

			.policy-status {
				padding: 6px 12px;
				border-radius: 20px;
				font-size: 12px;
				font-weight: 500;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 5px 10px;
					font-size: 11px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 4px 8px;
					font-size: 10px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 3px 6px;
					font-size: 10px;
					display: inline-block;
					text-align: center;
					min-width: 60px;
				}
			}

			.status-0 {
				background: #ebeae6;
				color: #6b6a69;
			}
			
			.status-1 {
				background: #fff3e0;
				color: #ef6c00;
			}

			.status-2 {
				background: #e8f5e9;
				color: #2e7d32;
			}
			
			.status-3 {
				background: #ebeae6;
				color: #6b6a69;
			}
			
			.status-4 {
				background: #ebeae6;
				color: #6b6a69;
			}
			
			.policy-actions {
				display: flex;
				gap: 8px;

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					gap: 6px;
					flex-direction: column;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					gap: 4px;
					flex-direction: column;
				}
			}

			.action-btn {
				padding: 6px 12px;
				border: 1px solid #e0e0e0;
				border-radius: 6px;
				background: white;
				color: #666;
				font-size: 12px;
				cursor: pointer;
				transition: all 0.3s ease;
				white-space: nowrap;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 5px 10px;
					font-size: 11px;
				}

				/* 平板适配 */
				@media (max-width: 1023px) and (min-width: 768px) {
					padding: 4px 8px;
					font-size: 10px;
				}

				/* 手机适配 */
				@media (max-width: 767px) {
					padding: 3px 6px;
					font-size: 10px;
					min-width: 60px;
				}
			}

			.action-btn:hover {
				border-color: #2280FD;
				color: #2280FD;
			}

			.action-btn.primary {
				background: #2280FD;
				color: white;
				border-color: #2280FD;
			}

			.action-btn.primary:hover {
				background: #1a6fd0;
			}
		}
	}
</style>